export default __webpack_public_path__ + "b9ae8f4ea491351720e9fdbecc02646a.svg";